export const FETCH_TABLE_DATA =
  'react-boilerplate/LiveDashboard/Graphs/FETCH_TABLE_DATA';
export const FETCH_GRAPH_LINE_DATA =
  'react-boilerplate/LiveDashboard/Graphs/FETCH_GRAPH_LINE_DATA';
export const CHANGE_CHART_CONFIG =
  'react-boilerplate/LiveDashboard/Graphs/CHANGE_CHART_CONFIG';
export const BASE_64_STRING =
  'react-boilerplate/LiveDashboard/Graphs/BASE_64_STRING';
export const GET_TABLE_MAPPING =
  'react-boilerplate/LiveDashboard/Graphs/GET_TABLE_MAPPING';
export const CHANGE_CHART =
  'react-boilerplate/LiveDashboard/Graphs/CHANGE_CHART';
export const CHANGE_TABLE =
  'react-boilerplate/LiveDashboard/Graphs/CHANGE_TABLE';
export const CLEAR_TABLE_DATA =
  'react-boilerplate/LiveDashboard/Graphs/CLEAR_TABLE_DATA';

export interface GraphConfigData {
  as: string;
  configs: unknown[];
  element: string;
  end: string;
  index: number;
  interval: string;
  start: string;
  title: string;
  type: string;
  help?: string;
}

export interface TableConfigData {
  columns: string[];
  element: string;
  end: string;
  index: number;
  shops: number[];
  start: string;
  title: string;
  type: string;
  pageSize: number;
  api: string;
  help?: string;
}

export const changeChart = (data: GraphConfigData) => ({
  type: CHANGE_CHART,
  index: data.index,
  newConfig: data,
  meta: {
    type: 'api',
    url: 'dashboard/views',
    method: 'put',
    data: {
      as: data.as,
      configs: data.configs,
      element: data.element,
      end: data.end,
      index: data.index,
      interval: data.interval,
      start: data.start,
      title: data.title,
      type: data.type,
      help: data.help,
    },
  },
});

export const fetchGraphLineData = (
  index: number,
  params: string,
  configIndex: number,
) => ({
  type: FETCH_GRAPH_LINE_DATA,
  index,
  configIndex,
  meta: {
    type: 'api',
    url: `data?${params}`,
    method: 'get',
  },
});

export const changeChartConfig = (data: GraphConfigData) => ({
  type: CHANGE_CHART_CONFIG,
  index: data.index,
  newConfig: data,
  meta: {
    type: 'api',
    url: 'dashboard/views',
    method: 'put',
    data: {
      as: data.as,
      configs: data.configs,
      element: data.element,
      end: data.end,
      index: data.index,
      interval: data.interval,
      start: data.start,
      title: data.title,
      type: data.type,
      help: data.help,
    },
    error: {
      400: 'Wrong request.',
      500: 'Server temporary unavailable.',
    },
  },
});

export const fetchTableData = (
  index: number,
  params: string,
  api = 'transactions',
) => ({
  type: FETCH_TABLE_DATA,
  index,
  meta: {
    type: 'api',
    url: `${api}?${params}`,
    method: 'get',
  },
});

export const clearTableData = (index: number) => ({
  type: CLEAR_TABLE_DATA,
  index,
});

export const changeTable = (data: TableConfigData) => ({
  type: CHANGE_TABLE,
  index: data.index,
  newConfig: data,
  meta: {
    type: 'api',
    url: 'dashboard/views',
    method: 'put',
    data: {
      columns: data.columns,
      element: data.element,
      end: data.end,
      help: data.help,
      index: data.index,
      shops: data.shops,
      start: data.start,
      title: data.title,
      type: data.type,
      pageSize: data.pageSize,
      api: data.api,
    },
  },
});

export const base64String = (id: number, base64: string) => ({
  type: BASE_64_STRING,
  base64,
  id,
});

export const getTableMapping = (
  index: number,
  api = 'regainTableColumns',
) => ({
  type: GET_TABLE_MAPPING,
  index,
  meta: {
    type: 'api',
    url: `dashboard/${api}`,
    method: 'get',
  },
});
